/** Pie chart ratio for storage share (used / quota). */
export function clamp01(v: number): number {
  if (!Number.isFinite(v)) return 0;
  return Math.min(1, Math.max(0, v));
}

/** Native confirm for destructive local cleanup (sync page only). */
export function confirmSyncLocalDelete(message: string): boolean {
  // oxlint-disable-next-line no-alert -- intentional; no modal shell on sync cleanup tab yet
  return window.confirm(message);
}

/** Confirm forced catalog re-apply (ignores server catalog_revision match). */
export function confirmSyncForceCatalogDownload(): boolean {
  // oxlint-disable-next-line no-alert -- intentional; support action on sync tab
  return window.confirm(
    '¿Forzar descarga de catálogos? Se volverá a aplicar el JSON del servidor aunque la revisión coincida con la última descarga. Use esto solo si los datos locales no reflejan el servidor.',
  );
}

/** Confirm cache wipe / optional local SQLite delete before reload. */
export function confirmAppMaintenanceReset(wipeLocalSqlite: boolean): boolean {
  const wipeMsg = wipeLocalSqlite
    ? ' También se eliminarán entregas, reposiciones y catálogos guardados en este dispositivo (las fotos y firmas se conservan) y se cerrará la sesión.'
    : ' Se conservan los datos locales; solo se limpia la caché de la app.';
  // oxlint-disable-next-line no-alert -- intentional; destructive maintenance action
  return window.confirm(
    `¿Actualizar la aplicación? Se limpiará la caché al máximo y se recargará el shell.${wipeMsg} Cierre otras pestañas de esta app antes de continuar. Esta acción no se puede deshacer.`,
  );
}

/** Confirm OTA APK download and system install prompt. */
export function confirmApkUpdateInstall(versionName: string, versionCode: number): boolean {
  // oxlint-disable-next-line no-alert -- intentional; sideload install
  return window.confirm(
    `¿Descargar e instalar la versión ${versionName} (código ${versionCode})? Android abrirá el instalador del sistema; confirme allí para completar la actualización.`,
  );
}

/** IEC-style label for Sync UI copy (Spanish context). */
export function formatBytesEs(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  if (bytes === 0) return '0 B';
  const u = ['B', 'KiB', 'MiB', 'GiB', 'TiB'] as const;
  let n = bytes;
  let i = 0;
  while (n >= 1024 && i < u.length - 1) {
    n /= 1024;
    i++;
  }
  let d: number;
  if (i === 0) {
    d = 0;
  } else if (n < 10) {
    d = 2;
  } else if (n < 100) {
    d = 1;
  } else {
    d = 0;
  }
  return `${n.toFixed(d)} ${u[i]}`;
}
